import React from 'react';
import { CaretLeft, CaretRight } from 'phosphor-react';
import { cn } from './cn';

// Compact month stepper: ◀  Tháng 6, 2026  ▶ . value = { month (1-12), year }.
export function MonthYearPicker({ value, onChange, className }) {
    const { month, year } = value;
    function shift(delta) {
        let m = month + delta, y = year;
        if (m < 1) { m = 12; y -= 1; }
        if (m > 12) { m = 1; y += 1; }
        onChange({ month: m, year: y });
    }
    return (
        <div className={cn('inline-flex items-center gap-1 rounded-full bg-espresso/[0.05] p-1 ring-1 ring-espresso/10', className)}>
            <button aria-label="Tháng trước" onClick={() => shift(-1)}
                className="flex h-8 w-8 items-center justify-center rounded-full text-espresso-soft transition-all duration-300 ease-fluid hover:bg-cream-50 hover:text-espresso active:scale-95">
                <CaretLeft size={16} weight="bold" />
            </button>
            <span className="min-w-[8.5rem] text-center text-sm font-semibold text-espresso tnum">Tháng {month}, {year}</span>
            <button aria-label="Tháng sau" onClick={() => shift(1)}
                className="flex h-8 w-8 items-center justify-center rounded-full text-espresso-soft transition-all duration-300 ease-fluid hover:bg-cream-50 hover:text-espresso active:scale-95">
                <CaretRight size={16} weight="bold" />
            </button>
        </div>
    );
}
